import { render, staticRenderFns } from "./SyntheseCompletude.vue?vue&type=template&id=1bef5346"
import script from "./SyntheseCompletude.vue?vue&type=script&lang=js"
export * from "./SyntheseCompletude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports